import * as React from "react";
import { useSelector } from "react-redux";
import { StudentService } from "../../components/studentService";
import { Table } from "../../components/tableLoader";
import {
  ErrataWidget,
  ProgressWidget,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import * as cls from "./onlineSchedule.module.scss";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
function OnlineSchedule(props) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [data, setData] = React.useState(null);
  const title = "Онлайн-занятия";
  const icon = "clipboard_list";

  async function getTableData() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/online_schedule",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      const table = await StudentService.send(request, (response) => {});
      if (!table.errors) {
        table.columns.forEach((element) => {
          if (element.field === "link") {
            element.type = "jsx";
          }
          if (element.field === "start_date") {
            element.type = "dateTime";
          }
          if (element.field === "video_record") {
            element.type = "html";
          }
        });
        table.rows = table.rows.map((row) => {
          let btnLabel;
          const cleaned = row.start_date.replace("г.", "").trim();
          const [datePart, timePart] = cleaned.split(" - ");
          const [day, month, year] = datePart.split(".");

          const start = new Date(`${year}-${month}-${day}T${timePart}:00`);
          const now = new Date();

          const diffMinutes = Math.floor((start - now) / 60000);
          const passedMinutes = Math.floor((now - start) / 60000);

          if (passedMinutes >= 90) {
            btnLabel = "Завершилось";
          } else if (
            (diffMinutes <= 5 && diffMinutes >= 0) ||
            (passedMinutes >= 0 && passedMinutes < 90)
          ) {
            btnLabel = "Перейти";
          } else if (now < start) {
            btnLabel = "Не началось";
          }
          let isDisabled = btnLabel !== "Перейти";
          return {
            ...row,
            link: (
              <a
                href={isDisabled ? undefined : row.link}
                target="_blank"
                className={`${cls.normal} ${cls.btn} ${
                  isDisabled ? cls.disabled : cls.btnDefaultColor
                }`}
                onClick={isDisabled ? (e) => e.preventDefault() : undefined}
              >
                {btnLabel}
              </a>
            ),
          };
        });
        setData(table);
      } else if (table.error_type !== "auth") {
        setData(table);
      } else {
        const errorEvent = new ErrorEvent("error", {
          error: table,
        });
        window.dispatchEvent(errorEvent);
        return;
      }
    }
  }
  React.useEffect(() => {
    let timeoutId;
    const fetchTable = () => {
      getTableData();
      timeoutId = setTimeout(fetchTable, 10000);
    };
    fetchTable();
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  if (!data) return <ProgressWidget title={title} />;
  if (data.errors) {
    if (data.error_type === "info") {
      return (
        <WidgetFrame title={title} icon={icon} {...props}>
          <ErrataViewInfo errata={data} />
        </WidgetFrame>
      );
    } else if (data.error_type !== "info") {
      return <ErrataWidget errata={data} />;
    }
  }
  return (
    <WidgetFrame title={title} icon={icon}>
      <Table {...data} />
    </WidgetFrame>
  );
}

export default OnlineSchedule;
